export default __webpack_public_path__ + "media/images/theme/m_logo_dark-6efb219d04e4596936d00ac84428b147.png";